// extracted by mini-css-extract-plugin
export var bodySections = "_6l-8";
export var gray = "_6l-7";
export var green = "_6l-4";
export var iconContainer = "_6l-9";
export var iconWidgetContainer = "_6l-1";
export var phoneIcon = "_6l-2";
export var red = "_6l-5";
export var statusDot = "_6l-3";
export var widgetContainer = "_6l-0";
export var yellow = "_6l-6";